// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adminLayout {\n  width: 100%;\n  height: auto;\n}\n\n.adminLayout .adminLayout__content {\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  min-height: 100vh;\n}\n\n.adminLayout .adminLayout__body {\n  padding: 1rem 2rem;\n  flex: 1 1;\n}", ""]);
// Exports
module.exports = exports;
